import { ChildrenItem } from "dependencies/base"
import { PageLayout } from "./model"
import { home,homeOld, bs, appHome,appHomeOld, drawer_home, drawer_appHome } from "./diffrence_options"
// import icon from "../../assets/images/leftMenu/basePortal/icon_button.png"
// import icon from "../../assets/images/homeLeftMenu/base/icon_auto_layout_v.png"
import bigScreenIcon from "assets/images/leftMenu/base/cx_button.png"

let icon = "icon-portal-auto_layout_v"
export let pageLayout_children = []
export let pageLayout_children_old= []
export let bigScreen_pageLayout_children = []
export let app_pageLayout_children = []
export let app_pageLayout_children_old = []
export let drawer_pageLayout_children = []
export let drawer_app_pageLayout_children = []
for (let i = 0; i < home.length; i++) {
  pageLayout_children.push(new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(home[i])))
}
for (let i = 0; i < homeOld.length; i++) {
  pageLayout_children_old.push(new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(homeOld[i])))
}
for (let i = 0; i < bs.length; i++) {
  bigScreen_pageLayout_children.push(new ChildrenItem("布局" + i, bigScreenIcon, "cxPageLayout", new PageLayout(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_pageLayout_children.push(new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(appHome[i])))
}
for (let i = 0; i < appHomeOld.length; i++) {
  app_pageLayout_children_old.push(new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(appHomeOld[i])))
}
for (let i = 0; i < drawer_home.length; i++) {
  drawer_pageLayout_children.push(new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(drawer_home[i])))
}
for (let i = 0; i < drawer_appHome.length; i++) {
  drawer_app_pageLayout_children.push(
    new ChildrenItem("布局" + i, icon, "cxPageLayout", new PageLayout(drawer_appHome[i]))
  )
}
